/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Minwidth1Inputs */

const en_entity_minwidth1 = /** @type {(inputs: Entity_Minwidth1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min Width`)
};

const de_entity_minwidth1 = /** @type {(inputs: Entity_Minwidth1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimale Breite`)
};

/**
* | output |
* | --- |
* | "Min Width" |
*
* @param {Entity_Minwidth1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_minwidth1 = /** @type {((inputs?: Entity_Minwidth1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Minwidth1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_minwidth1(inputs)
	return de_entity_minwidth1(inputs)
});
export { entity_minwidth1 as "entity_minWidth" }